document.addEventListener("DOMContentLoaded", function () {
  // Find all text blocks with riddle matcher data
  const textBlocks = document.querySelectorAll(
    ".how-it-works__text[data-riddle-matcher][data-riddle-key]"
  );

  // Find all heading blocks with riddle matcher data
  const headingBlocks = document.querySelectorAll(
    ".how-it-works__heading[data-riddle-matcher][data-riddle-key]"
  );

  // Process text blocks
  textBlocks.forEach(function (textBlock) {
    const riddleMatcher = textBlock.getAttribute("data-riddle-matcher");
    const riddleKey = textBlock.getAttribute("data-riddle-key");

    // Only proceed if both matcher and key are present
    if (riddleMatcher && riddleKey) {
      // Process the text content to wrap matching text
      processTextNode(textBlock, riddleMatcher, riddleKey);

      // Remove the data attributes from the main div after processing
      textBlock.removeAttribute("data-riddle-matcher");
      textBlock.removeAttribute("data-riddle-key");
    }
  });

  // Process heading blocks
  headingBlocks.forEach(function (headingBlock) {
    const riddleMatcher = headingBlock.getAttribute("data-riddle-matcher");
    const riddleKey = headingBlock.getAttribute("data-riddle-key");

    // Only proceed if both matcher and key are present
    if (riddleMatcher && riddleKey) {
      // Process the heading content to wrap matching text
      processTextNode(headingBlock, riddleMatcher, riddleKey);

      // Remove the data attributes from the heading after processing
      headingBlock.removeAttribute("data-riddle-matcher");
      headingBlock.removeAttribute("data-riddle-key");
    }
  });
});

// Function to process text nodes and wrap matching text
function processTextNode(element, matcher, riddleKey) {
  // Create a walker to iterate through all text nodes
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    acceptNode: function (node) {
      // Skip text nodes that are already inside a span with data-riddle-key
      let parent = node.parentNode;
      while (parent && parent !== element) {
        if (
          parent.tagName === "SPAN" &&
          parent.hasAttribute("data-riddle-key")
        ) {
          return NodeFilter.FILTER_REJECT;
        }
        parent = parent.parentNode;
      }
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const textNodes = [];
  let node;

  // Collect all text nodes first to avoid modifying the DOM while iterating
  while ((node = walker.nextNode())) {
    textNodes.push(node);
  }

  // Process each text node
  textNodes.forEach(function (textNode) {
    const text = textNode.textContent;
    const regex = new RegExp(`(${escapeRegExp(matcher)})`, "gi");

    if (regex.test(text)) {
      // Create a temporary container
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text.replace(regex, function (match) {
        return `<span data-riddle-key="${riddleKey}">${match}</span>`;
      });

      // Replace the text node with the new content
      const fragment = document.createDocumentFragment();
      while (tempDiv.firstChild) {
        fragment.appendChild(tempDiv.firstChild);
      }

      textNode.parentNode.replaceChild(fragment, textNode);
    }
  });
}

// Helper function to escape special regex characters
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
